export default "__VITE_ASSET__C2TgCd8H__"